import DetailedFeatures from "../../ui/vdp-block-components/vdp-detailed-features/detailed-features";
import DealerLocation from "../../ui/vdp-block-components/vdp-location/location";
import BasicInfo from "../../ui/vdp-block-components/vdp-basic-info/basic-info";
import EVSavingsBadge from "./lectrum/vdp-ev-savings-badge/ev-savings-badge";
import EVRangeMap from "./lectrum/vdp-ev-range-map/ev-range-map";
import PriceDetails, {
  VDPPriceDetailsGlobalInitHook,
} from "../../ui/vdp-block-components/vdp-price-details/price-details";
import PopularFeatures from "../../ui/vdp-block-components/vdp-popular-features/popular-features";
import Description from "../../ui/vdp-block-components/vdp-description/description";
import VDPGallery from "../../ui/vdp-block-components/vdp-gallery/vdp-gallery";
import VDPDisclaimer from "../../ui/vdp-block-components/vdp-disclaimer/vdp-disclaimer";
import VDPSimilarVehicles from "../../ui/vdp-block-components/vdp-similar-vehicles/similar-vehicles";
import CarfaxHistoryReport from "./vdp-carfax-history-report/history-report";
import VDPEdmundsTradeInToool from "./vdp-edmunds-trade-in-tool";
import VDPHtmlInline from "./vdp-html-inline";
import VDPSidebarConditionalContent from "./vdp-sidebar-conditional-content/vdp-sidebar-conditional-content";
import { VDPComponentGlobalInitHook } from "../../types/vdp";

export function getVdpBlockDataForComponent(blockName: string) {
  switch (blockName) {
    case "vdp-basic-info":
      return BasicInfo;
    case "vdp-detailed-features":
      return DetailedFeatures;
    case "vdp-dealer-location":
      return DealerLocation;
    case "vdp-price-details":
      return PriceDetails;
    case "vdp-popular-features":
      return PopularFeatures;
    case "vdp-description":
      return Description;
    case "vdp-gallery":
      return VDPGallery;
    case "vdp-disclaimer":
      return VDPDisclaimer;
    case "vdp-similar-vehicles":
      return VDPSimilarVehicles;
    case "vdp-carfax-history":
      return CarfaxHistoryReport;
    case "lead-popup":
      break;
    case "edmunds-trade-in-tool":
      return VDPEdmundsTradeInToool;
    case "vdp-html-inline":
      return VDPHtmlInline;
    case "vdp-lectrum-ev-savings-badge":
      return EVSavingsBadge;
    case "vdp-lectrum-ev-range-map":
      return EVRangeMap;
    case "vdp-sidebar-conditional-content":
      return VDPSidebarConditionalContent;
    default:
      console.error("unknown vdp block", blockName);
      return undefined;
  }
}

export function getVdpGlobalInitHookForComponent(blockName: string): VDPComponentGlobalInitHook | undefined {
  switch (blockName) {
    case "vdp-price-details":
      return VDPPriceDetailsGlobalInitHook;
  }
  return undefined;
}
